module.exports = __webpack_public_path__ + "static/firefox-5a753210928e76500641e9e480920a79.png";